//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ImageUploader from "../../components/ImageUploader";
import moment from "moment";

export default {
  name: "activeForm",
  components: {ImageUploader},
  data() {
    return {
      id: 0,//活动id
      signUpCost: 0,
      signUpInfo: {
        image: {
          associateType: 'SingUpImage',
          addAttrIds: [],
          delAttrIds: [],
        },
        description: ''
      },
      member: {},
      saving: false,
      fileList: [],
      isUpload: false,
      show: false,
      showAction: false,
      minDate: new Date(),
      maxDate: new Date(),
      activityInfo: {},
      timeSlotList: []
    };
  },
  computed: {},
  methods: {
    getMyMember() {
      var vm = this;
      vm.$toast.loading({
        duration: 0,
        message: ''
      });

      vm.$store.dispatch({
        type: 'member/getMyMember'
      }).then(() => {
        vm.member = {};
        vm.signUpInfo = {
          image: {
            associateType: 'SingUpImage',
            addAttrIds: [],
            delAttrIds: [],
          },
          description: ''
        };
        vm.member = vm.$store.state.member.memberInfo;
        vm.signUpInfo.name = vm.member.name;
        vm.signUpInfo.phoneNumber = vm.member.phoneNumber;
        vm.signUpInfo.emailAddress = vm.member.emailAddress;
        vm.signUpInfo.memberId = vm.member.id;
        localStorage.setItem('MemberId', vm.member.id);
      }).finally(() => {
        vm.$toast.clear();
      });
    },
    onSaveSignUp() {
      var vm = this;
      vm.signUpInfo.activityId = this.id;

      if (!vm.signUpInfo.activityDate) {
        this.$toast('请选择日期！')
        return;
      }

      if (vm.timeSlotList.length > 0) {
        if (!vm.signUpInfo.timeSlot) {
          this.$toast('请选择时段！')
          return;
        }
      }

      if (!vm.signUpInfo.memberId > 0) {
        vm.$toast('会员不存在');
        return
      }
      if (!this.signUpInfo.name) {
        this.$toast('请输入姓名');
        return;
      }
      if (!/^1[123456789]\d{9}$/.test(this.signUpInfo.phoneNumber)) {
        this.$toast('手机号格式无效');
        return;
      }

      if (this.isUpload) {
        if (vm.signUpInfo.image.addAttrIds.length === 0) {
          this.$toast('请上传图片')
          return;
        }
      }
      // return;
      // this.signUpInfo.activityDate='2021-12-01'
      vm.saving = true;
      abp.ajax.post('/api/services/app/Activity/SaveSignUp', vm.signUpInfo).then(res => {

        vm.$router.replace({
          name: 'activeApplySuc'
        })

      }).finally(() => {
        vm.saving = false;
      });

    },

    getActiveDetail() {
      var vm = this;
      vm.$store.dispatch({
        type: 'activity/GetActivityById',
        id: this.id
      }).then(res => {
        vm.activityInfo = vm.$store.state.activity.activityInfo;

        if (vm.activityInfo.startDateTime) {
          let st = vm.activityInfo.startDateTime.substring(0, 10);
          let sArr = st.split('-').map(Number);
          vm.minDate = new Date(sArr[0], sArr[1]-1, sArr[2]);

          let et = vm.activityInfo.endDateTime.substring(0, 10);
          let eArr = et.split('-').map(Number);
          vm.maxDate = new Date(eArr[0], eArr[1]-1, eArr[2]);
        }

        vm.timeSlotList = []
        let tArr = [];
        if (vm.activityInfo.timeSlot) {
          tArr = vm.activityInfo.timeSlot.split(/[\n]/)

          tArr.forEach(item => {
            if (item.replace(/(^s*)|(s*$)/g, "").length != 0) {
              vm.timeSlotList.push({
                name: item
              })
            }
          })
        }
        //
        // console.log(vm.activityInfo.timeSlot)
        // console.log(vm.activityInfo.timeSlot.length)
        // console.log(vm.activityInfo.timeSlot.replace(/(^s*)|(s*$)/g, '').length)
      })
    },

    formatDate(date) {
      var m = date.getMonth() + 1;
      if (m < 10) {
        m = '0' + m;
      }
      var d = date.getDate();
      if (d < 10) {
        d = '0' + d;
      }
      return `${date.getFullYear()}-${m}-${d}`;
    },
    onSelectDate(date) {
      this.signUpInfo.activityDate = this.formatDate(date);
      this.show = false;
    },

    timeSlotSelect(action, index) {
      this.signUpInfo.timeSlot = action.name;
    }
  },
  created() {
    // this.loading = true;
    // this.getActiveList();
    this.id = parseInt(this.$route.params.id);
    if (this.id > 0) {
      this.getActiveDetail()
    }
    this.signUpCost = this.$route.params.price;
    if ((this.$route.params.isUpLoad).toString() === "true") {
      this.isUpload = true;
    } else {
      this.isUpload = false;
    }
    this.getMyMember();


  }
}
